import { createFileRoute } from '@tanstack/react-router';
import { S3AssetDetail } from '@/screens/S3AssetDetail/S3AssetDetail';
import { useApiClients } from '@/app/ApiProvider';

export const Route = createFileRoute('/$orgId/assets/$id')({
  component: AssetScreen,
});

function AssetScreen() {
  const { id } = Route.useParams();
  const clients = useApiClients();
  return <S3AssetDetail assetId={id} clients={clients} />;
}
